import React, { useEffect, useState, useRef } from "react";

const GoogleTranslateWidget1 = () => {
  const [selectedLang, setSelectedLang] = useState("en");
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const isMounted = useRef(false);

  const languageOptions = [
    { code: "en", name: "English", flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg" },
    { code: "nl", name: "Dutch", flag: "https://upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_the_Netherlands.svg" },
    { code: "pt", name: "Portuguese", flag: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Portugal.svg" },
    { code: "fr", name: "French", flag: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_France.svg" },
    { code: "de", name: "German", flag: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg" },
    { code: "es", name: "Spanish", flag: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg" },
    { code: "uk", name: "Ukrainian", flag: "https://upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Ukraine.svg" }
  ];

  // Restore language from existing Google Translate cookie if present
  useEffect(() => {
    isMounted.current = true;
    const match = document.cookie.match(/googtrans=\/[a-zA-Z-]+\/([a-zA-Z-]+)/);
    if (match && match[1]) {
      const code = match[1];
      if (languageOptions.some((l) => l.code === code)) {
        setSelectedLang(code);
      }
    }
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Update selected language display when selectedLang changes
  useEffect(() => {
    const lang = languageOptions.find((l) => l.code === selectedLang);
    setSelectedLanguage(lang || languageOptions[0]);
  }, [selectedLang]);

  useEffect(() => {
    const addGoogleTranslateScript = () => {
      if (!document.getElementById("google-translate-script")) {
        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.type = "text/javascript";
        script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
      }
    };

    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = () => {
        try {
          if (window.google && window.google.translate) {
            new window.google.translate.TranslateElement(
              {
                pageLanguage: "en",
                includedLanguages: "en,nl,pt,fr,de,es,uk",
                autoDisplay: false,
              },
              "google_translate_element"
            );
          }
        } catch (e) {
          console.warn("Google Translate init handled safely:", e);
        }

        const selectBox = document.querySelector(".goog-te-combo");
        if (selectBox) {
          selectBox.addEventListener("change", (event) => {
            if (isMounted.current) {
              setSelectedLang(event.target.value);
            }
          });
        }
      };
      addGoogleTranslateScript();
    }
  }, []);

  useEffect(() => {
    const selectBox = document.querySelector(".goog-te-combo");
    if (selectBox && selectBox.value !== selectedLang) {
      selectBox.value = selectedLang;
      selectBox.dispatchEvent(new Event("change"));
    }
  }, [selectedLang]);

  const handleSelect = (langCode) => {
    setSelectedLang(langCode);
    setIsOpen(false);

    // Set Google Translate cookie for persistence across reloads
    try {
      document.cookie = `googtrans=/en/${langCode}; path=/;`;
      document.cookie = `googtrans=/en/${langCode}; domain=${window.location.hostname}; path=/;`;
    } catch (e) {
      // Ignore cookie errors
    }

    const selectBox = document.querySelector(".goog-te-combo");
    if (selectBox) {
      selectBox.value = langCode;
      selectBox.dispatchEvent(new Event("change"));
    }
  };

  return (
    <div className="d-flex align-items-center notranslate" translate="no">
      {/* Singleton container for Google Translate element */}
      <div id="google_translate_element" style={{ display: "none" }}></div>

      <div className="custom-language-selector me-3 notranslate" translate="no">
        <div className="custom-select" onClick={() => setIsOpen(!isOpen)}>
          <div className="selected-option notranslate" translate="no">
            {selectedLanguage && (
              <>
                <img
                  src={selectedLanguage.flag}
                  alt={selectedLanguage.name}
                  style={{ width: "20px", height: "15px", marginRight: "8px" }}
                />
                <span className="notranslate" translate="no">
                  {selectedLanguage.name}
                </span>
              </>
            )}
          </div>

          {isOpen && (
            <div className="dropdown-options notranslate" translate="no">
              {languageOptions.map((lang) => (
                <div
                  key={lang.code}
                  className="dropdown-option notranslate"
                  translate="no"
                  onClick={() => handleSelect(lang.code)}
                >
                  <img
                    src={lang.flag}
                    alt={lang.name}
                    style={{ width: "20px", height: "15px", marginRight: "8px" }}
                  />
                  <span className="notranslate" translate="no">
                    {lang.name}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleTranslateWidget1;